import React, { useState, useRef, useEffect } from 'react';

function SearchableDropdown({
  value = '',
  onChange,
  onSelect,
  options = [],
  placeholder = '',
  name = '',
  id = ''
}) {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  const filteredOptions = options.filter(option =>
    option.toLowerCase().includes((value || '').trim().toLowerCase())
  );

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleSelect = (option) => {
    if (onSelect) {
      onSelect(option);
    } else if (onChange) {
      onChange(option);
    }
    setIsOpen(false);
  };

  return (
    <div className="searchable-dropdown-container" ref={containerRef}>
      <div className="searchable-dropdown-input-wrapper">
        <input
          type="text"
          id={id}
          name={name}
          value={value}
          placeholder={placeholder}
          autoComplete="off"
          onChange={(e) => {
            onChange(e.target.value);
            if (!isOpen) setIsOpen(true);
          }}
          onFocus={() => setIsOpen(true)}
        />
        <button
          type="button"
          tabIndex="-1"
          className={`searchable-dropdown-toggle ${isOpen ? 'open' : ''}`}
          onClick={() => setIsOpen(prev => !prev)}
          title="Toggle dropdown"
        >
          ▼
        </button>
      </div>

      {isOpen && (
        <ul className="searchable-dropdown-menu">
          {filteredOptions.length > 0 ? (
            filteredOptions.map((option, idx) => (
              <li
                key={idx}
                className={`searchable-dropdown-item ${
                  option.toLowerCase() === (value || '').toLowerCase() ? 'active' : ''
                }`}
                onMouseDown={(e) => {
                  e.preventDefault();
                  handleSelect(option);
                }}
              >
                {option}
              </li>
            ))
          ) : (
            <li className="searchable-dropdown-empty">
              {value ? `No matches found for "${value}"` : 'No options available'}
            </li>
          )}
        </ul>
      )}
    </div>
  );
}

export default SearchableDropdown;
